/**
 * Typography Tokens (Internal Design System)
 *
 * Single source of truth for typography values.
 */

export const typography = {
  fontFamily: {
    heading: 'Merriweather, serif',
    body: 'Lato, sans-serif',
    mono: 'Monaco, Consolas, "Courier New", monospace',
  },
  fontSize: {
    micro: '0.625rem',
    xxs: '0.75rem',
    xs: '0.875rem',
    sm: '1rem',
    md: '1.125rem',
    lg: '1.25rem',
    xl: '1.5rem',
    xxl: '1.75rem',
    huge: '2.5rem',
    mega: '3rem',
    giga: '3.75rem',
    tera: '5.625rem',
  },
  lineHeight: {
    compact: '100%',
    tight: '125%',
    normal: '150%',
    relaxed: '175%',
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  letterSpacing: {
    tight: '0.00625rem',
    normal: '0.01rem',
    relaxed: '0.015625rem',
    wide: '0.020625rem',
    caps: '0.0625rem',
  },
  /**
   * Numeric pixel values for APIs that require numbers (e.g., MUI CircularProgress).
   * These correspond to the same scale as fontSize but as raw pixel numbers.
   */
  fontSizePx: {
    micro: 10,
    xxs: 12,
    xs: 14,
    sm: 16,
    md: 18,
    lg: 20,
    xl: 24,
    xxl: 28,
    xxxl: 36,
    huge: 40,
    mega: 48,
    giga: 60,
    tera: 90,
  },
} as const

export type Typography = typeof typography
